module.exports = __webpack_public_path__ + "img/img-scholarshipprogram1@3x.b9260fc6.jpg";